module.exports = __webpack_public_path__ + "img/internet6.efc20487.png";